<div class="photo-selection-dialog">
  <header class="photo-selection-dialog__header">
    <h2>{{ 'PhotoSelectionDialog.title' | translate }}</h2>
    <div class="photo-selection-dialog__header-actions">
      <app-button variant="floating" color="primary" icon="check" size="lg" (clicked)="onConfirm()"> </app-button>
      <app-button variant="floating" icon="close" size="lg" (clicked)="onCancel()"> </app-button>
    </div>
  </header>

  <div class="photo-selection-dialog__content">
    @if (images().length > 0) {
      <app-image-grid [images]="images()" expandTrigger="button">
        <app-button
          *appImageGridThumbnailElement="let image; let i = index; position: 'top-right'"
          variant="floating"
          [color]="isSelected(i) ? 'primary' : 'light'"
          [icon]="isSelected(i) ? 'check' : undefined"
          size="lg"
          (clicked)="togglePhotoSelection(i)"
        ></app-button>
      </app-image-grid>
    } @else {
      <p class="photo-selection-dialog__empty">{{ 'PhotoSelectionDialog.noPhotos' | translate }}</p>
    }
  </div>
</div>
